/**
 * name: petails-wizard-key
 * version: 1.0.0
 * created: 2026-09-15
 * updated: 2026-09-15
 * author: Raffaello + Claude (AI-assisted)
 * status: active
 * purpose: Browser-tier token for the X-Petails-Secret header, isolated from the engine.
 * deps: [petails-wizard-section, petails-wizard-js]
 * changelog:
 * - [1.0.0] 2026-09-15 (Raffaello + Claude): Extracted from petails-wizard.js so the engine
 *   carries no credential literal and a rotation is a one-line upload instead of a 72KB one.
 *   Browser tier is public by design: this value has always shipped in page source. Same
 *   header name, same value, same tier - contract CONTRACT-03 auth tiers are untouched.
 */
window.__PW_BROWSER_KEY = 'pbrw_p0CnDv3HszyoqbV8B6YkAopR8VUCWHqg';
